import { Component, Input } from '@angular/core';
import { UserPermission } from '@techspert-io/auth';

export interface ISideBarRoute {
  label: string;
  route: string;
  icon: string;
  permissions?: UserPermission[];
}

@Component({
  selector: 'app-nav-menu-link',
  templateUrl: 'nav-menu-link.component.html',
  styleUrls: ['./nav-menu-link.component.scss'],
  standalone: false,
})
export class NavMenuLinkComponent {
  @Input() route: ISideBarRoute;
}
